module.exports = __webpack_public_path__ + "static/media/quiz_female_icon_active.dfc01e47.svg";